import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";
import { yang } from "@/images";

const findCard = [
  new Dialog(
    "SONNY YANG: Interesting...it’s a SHIBARI INTERNATIONAL EMPLOYEE KEYCARD. I always knew Dareth Schamren had a highfalutin' job.",
    yang,
    require("@/audio/Pandemic-58-Sonny-MP3.mp3")
  ),
  new Dialog(
    "[Acquired 1 x SHIBARI KEYCARD]",
    require("@/images/Shibari_Keycard.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

const nothing = [
  new Dialog(
    "SONNY YANG: There's nothing here of any significance.",
    yang,
    require("@/audio/Pandemic-44-Sonny-MP3.mp3")
  )
];

export class DarethsBedroom extends Scene {
  title = "Dareth's Bedroom";
  async init() {
    this.image = require("@/images/Dareths_Bedroom.png");
    this.audio = null
  }
  get options(): any[] {
    return [
      new Choice("Search Wardrobe", async () => {
        await this.dialogRunner(nothing)
      }),
      new Choice("Search Drawers", async () => {
        if (this.state.inventory.shibariKeyCard.has) {
          await this.dialogRunner(nothing)
        } else {
          await this.dialogRunner(findCard)
          this.state.inventory.shibariKeyCard.has = true;
        }
      }),
      new Choice("Go Back", async () => await this.navigate(scenes.DarethsUpstairs())),
    ];
  }
}

export default new DarethsBedroom();
